// this is only for mobile
import { FETCH_FILTERED_DATA_WORKOUTS } from './actionTypes'

export default () => ({
  type: FETCH_FILTERED_DATA_WORKOUTS,
  payload: {}
})